import { gql, useLazyQuery } from '@apollo/client';
import { useCallback, useRef } from 'react';
import { mentionReplacedDescription } from '../../../../../../javascript/components/HighlightedMentions/utils';
import { mapMentionableTasks } from './mapMentionableTasks';
import { DashboardTask } from './queries';

const SEARCH_PROJECT_TASKS = gql`
  query searchProjectTasks($projectId: ID!, $query: String!, $limit: Int) {
    currentUser {
      id
      userProject(id: $projectId) {
        id
        searchTasks(query: $query, limit: $limit) {
          id
          localTaskId
          display
          priorityId
        }
      }
    }
  }
`;

export const useTaskMentionSearch = ({
  projectId,
  task,
  bugherdUrl
}: {
  projectId: string;
  task: DashboardTask;
  bugherdUrl: string;
}) => {
  const [search] = useLazyQuery(SEARCH_PROJECT_TASKS, {
    fetchPolicy: 'network-only'
  });
  const timeoutRef = useRef<number>();

  const searchMentionableTasks = useCallback(
    (query: string, callback: (results: unknown[]) => void) => {
      window.clearTimeout(timeoutRef.current);
      if (!query.trim()) return callback([]);

      timeoutRef.current = window.setTimeout(async () => {
        const { data } = await search({
          variables: { projectId, query: query.trim(), limit: 20 }
        });
        const results = mapMentionableTasks(
          data?.currentUser?.userProject?.searchTasks || [],
          task,
          bugherdUrl
        )
          .filter(({ id }) => id !== Number(task.id))
          .map(({ localTaskId, id, display, severity }) => ({
            description: mentionReplacedDescription(display),
            display: `#${localTaskId}`,
            localTaskId,
            id,
            severity
          }));
        callback(results);
      }, 250);
    },
    [projectId, search, task, bugherdUrl]
  );

  return { searchMentionableTasks };
};
